import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import split from 'lodash/split';
import get from 'lodash/get';
import { COP } from 'payments-lib';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GroupFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { VisuallyHiddenBody } from 'web-ui-components/lib/typography/body';
import config from '../../config/index';
import AppStore from '../../stores/AppStore';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import { beneficiaryUpdateEventPayload } from '../../logic/BeneficiaryEventsBusinessLogic';
import StepHeader from '../../includes/StepHeader';
import { copCheckTriggeredHandler } from '../../utils/COPUtils';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import NumberUtils from '../../utils/NumberUtils';
import RegexUtils from '../../utils/RegexUtils';
import LoaderComponent from '../common/LoaderComponent';
import Button from '../common/ButtonComponent';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import { getSessionInfo } from '../managepayments/ManagePaymentsSMEUtils';
import EditPayeeSummary from './EditPayeeSummary';
import StringConstant from '../../constants/StringConstants';
import SessionStore from '../../stores/SessionStore';
import { StepUpWrapper } from '../session';
import SessionActionCreator from '../../actions/SessionActionCreator';

let doErrorExist = false;
let pFlag = false;
let sFlag = false;
let aFlag = false;
let rFlag = false;
let nFlag = false;
let anFlag = false;
let addingSameAccount = false;

const radioItems = [
  { id: 'Personal', labelText: 'Pay a person' },
  { id: 'Business', labelText: 'Pay a business' },
];

class EditPayeePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateDetails: true,
      name: this.props.payeeData.to_account.name,
      display_name: this.props.payeeData.display_name,
      sort_code: NumberUtils.formatSortCode(
        this.props.payeeData.to_account.sort_code
      ),
      account_number: this.props.payeeData.to_account.account_number,
      account_name: this.props.payeeData.cop_account_name,
      useLegacyName: !get(this.props, 'payeeData.cop_account_name'),
      reference: this.props.payeeData.reference,
      showEditPayeeSummary: false,
      showLoader: false,
      showErrorModal: false,
      errorResponse: {},
      showWarningModal: false,
      closeModal: true,
      isScheduledPaymentsWarningShown: false,
      closeErrorModal: true,
      isUpdateDisable: MoveMoneyPayeeStore.isUpdateEnable(),
      fraudRiskAccepted: false,
      showAccountHolderName: false,
      fieldBlurred: {
        name: false,
        sort_code: false,
        account_number: false,
        reference: false,
        display_name: false,
        account_name: false,
      },
      fieldValid: {
        name: true,
        sort_code: true,
        account_number: true,
        reference: true,
        display_name: true,
        account_name: true,
      },
      fieldChanged: {
        name: false,
        sort_code: false,
        account_number: false,
        reference: false,
        display_name: false,
        account_name: false,
      },
      callCOP: false,
      copCheckNeeded: false,
      accountType: this.props.payeeData.cop_account_type
        ? this.props.payeeData.cop_account_type
        : this.props.payeeData.hasOwnProperty('biller_id')
        ? 'Business'
        : '',
      tryCount: 1,
      isBiller:
        this.props.payeeData.hasOwnProperty('biller_id') &&
        this.props.payeeData?.cop_account_type === 'Business',
      isStepUpMode: false,
    };
    this.editDone = this.editDone.bind(this);
    this.updateValueState = this.updateValueState.bind(this);
    this.onChange = this.onChange.bind(this);
    this.setupStore = this.setupStore.bind(this);
    this.goToMoveMoneyPages = this.goToMoveMoneyPages.bind(this);
    this.goToViewPage = this.goToViewPage.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.showEditDetails = this.showEditDetails.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.hideInlineError = this.hideInlineError.bind(this);
    this.showInlineError = this.showInlineError.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.closeWarningModal = this.closeWarningModal.bind(this);
    this.updateAllDetails = this.updateAllDetails.bind(this);
    this.goToManagePayee = this.goToManagePayee.bind(this);
    this.returnLoader = this.returnLoader.bind(this);
    this.getFormatedSortCode = this.getFormatedSortCode.bind(this);
    this.removeHypenFromString = this.removeHypenFromString.bind(this);
    this.getSortCodeDisplayNumber = this.getSortCodeDisplayNumber.bind(this);
    this.getErrorMessage = this.getErrorMessage.bind(this);
    this.getInlineErrorMessage = this.getInlineErrorMessage.bind(this);
    this.isAddingSameAccount = this.isAddingSameAccount.bind(this);
    this.moveFocusOnSortCode = this.moveFocusOnSortCode.bind(this);
    this.handleCopResult = this.handleCopResult.bind(this);
    this.handleCOP = this.handleCOP.bind(this);
    this.buildCopPayeePayload = this.buildCopPayeePayload.bind(this);
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    if (this.props.payeeData.hasOwnProperty('biller_id')) {
      MoveMoneyPayeeStore.storeEditBillerData(this.props.payeeData);
    }
    MoveMoneyPayeeStore.storeEditPayeeData(this.props.payeeData);
    MoveMoneyPayeeStore.addChangeListener(this.onStoreChange);
    SessionStore.addChangeListener(this.onSessionStoreChange);
  }

  componentDidMount() {
    sayLandingMessage(this.props.content.editPageheaderTitle);
    this.setupStore();
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
  }

  componentWillUnmount() {
    MoveMoneyPayeeStore.removeChangeListener(this.onStoreChange);
    SessionStore.removeChangeListener(this.onSessionStoreChange);

    SessionActionCreator.clearStepUpSession();

    pFlag = false;
    sFlag = false;
    aFlag = false;
    rFlag = false;
    nFlag = false;
    anFlag = false;
  }

  onSessionStoreChange = () => {
    const isStepUpMode = SessionStore.isStepUpMode();

    this.setState({
      isStepUpMode,
      showLoader: SessionStore.isStepUpChallengeLoading(),
    });

    if (SessionStore.isStepUpCompleted()) {
      this.setState({
        showEditPayeeSummary: true,
      });
    }
  };

  onBlur(e) {
    const parent =
      e.currentTarget.attributes.getNamedItem('data-parent').textContent;
    const name = e.target.name;
    this.updateValueState(e.target.name, e.target.value.trim());
    if (
      e.target.name === this.props.content.payeeRequestPacket_sort_code &&
      e.target.value !== '' &&
      e.target.value.length === 6
    ) {
      const tempRemoveHypen = NumberUtils.formatSortCode(e.target.value);
      this.updateValueState(e.target.name, tempRemoveHypen);
    } else {
      this.updateValueState(e.target.name, e.target.value.trim());
    }
    this.state.fieldBlurred[name] = true;
    if (this.state.fieldValid[e.target.name]) {
      this.hideInlineError(parent, name);
    } else {
      this.showInlineError(parent, name);
    }
  }

  onChange(e) {
    const errorResponse = get(
      this.state.errorResponse,
      'coded_exceptions[0].error_status',
      undefined
    );
    if (!this.state.accountType) {
      this.setState({ updateDetails: true });
    } else {
      this.setState({ updateDetails: false });
    }
    const {
      target: { name },
    } = e;
    let parent;
    switch (name) {
      case 'name':
        const nameRegEx = new RegExp(`^[0-9A-Za-z&()\\._/ -]{0,138}`);
        const nameRes = String(e.target.value).match(nameRegEx);
        const nameData = nameRes[0].replace(/\s\s+/g, ' ');
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        if (!this.checkError(e.target.name, nameData, parent)) {
          MoveMoneyPayeeActionCreator.updateEditForm(e.target.name, nameData);
        }
        this.updateValueState(e.target.name, nameData);
        break;
      case 'sort_code':
        let Value = String(e.target.value);
        Value = this.removeHypenFromString(Value);
        let res = Value.match(/^[0-9-]{0,6}/);
        this.updateValueState(e.target.name, res[0]);
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        if (!this.checkError(e.target.name, res[0], parent)) {
          MoveMoneyPayeeActionCreator.updateEditForm(e.target.name, res[0]);
        }
        this.setState({ tryCount: 1 });
        const sortCodeValid = this.state.fieldValid['sort_code'];
        if (
          !isEmpty(this.state.errorResponse) &&
          errorResponse === 'Invalid Account' &&
          sortCodeValid
        ) {
          this.hideInlineError('accNumErr', 'account_number');
        }
        break;
      case 'account_number':
        let accValue = String(e.target.value);
        let accRes = accValue.match(/^[0-9]{0,8}/);
        this.updateValueState(e.target.name, accRes[0]);
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        if (!this.checkError(e.target.name, accRes[0], parent)) {
          MoveMoneyPayeeActionCreator.updateEditForm(e.target.name, accRes[0]);
        }
        this.setState({ tryCount: 1 });
        const accountValid = this.state.fieldValid['account_number'];
        if (
          !isEmpty(this.state.errorResponse) &&
          errorResponse === 'Invalid Account' &&
          accountValid
        ) {
          this.hideInlineError('sortCodeErr', 'sort_code');
        }
        break;
      case 'reference':
        const expression = RegexUtils.regexes.referenceRegex;
        const refRes = String(e.target.value).match(expression);
        let refData = refRes[0].replace(/\s\s+/g, ' ');
        if (refData.length > 0 && refData.charAt(0) === ' ') {
          refData = refData.trim();
        }
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        if (!this.checkError(e.target.name, refData, parent)) {
          MoveMoneyPayeeActionCreator.updateEditForm(
            e.target.name,
            refData.trim()
          );
        }
        this.updateValueState(e.target.name, refData);
        break;
      case 'display_name':
        const regExp = RegexUtils.regexes.nicknameRegex;
        const nicknameRes = String(e.target.value).match(regExp);
        const nicknameData = nicknameRes[0].replace(/\s\s+/g, ' ');
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        if (!this.checkError(e.target.name, nicknameData, parent)) {
          MoveMoneyPayeeActionCreator.updateEditForm(
            e.target.name,
            nicknameData
          );
        }
        this.updateValueState(e.target.name, nicknameData);
        break;
      case 'account_name':
        const accNameRes = String(e.target.value).match(
          /^[0-9A-Za-z&()\\._/ -]{0,138}/
        );
        const accNameData = accNameRes[0].replace(/\s\s+/g, ' ');
        parent =
          e.currentTarget.attributes.getNamedItem('data-parent').textContent;
        if (!this.checkError(e.target.name, accNameData, parent)) {
          MoveMoneyPayeeActionCreator.updateEditForm(
            e.target.name,
            accNameData
          );
        }
        this.updateValueState(e.target.name, accNameData);
        break;
      default:
        break;
    }

    this.setState((prevState) => ({
      fieldChanged: {
        ...prevState.fieldChanged,
        [name]: true,
      },
    }));
  }

  onStoreChange() {
    this.setState({ isUpdateDisable: MoveMoneyPayeeStore.isUpdateEnable() });
    const response = MoveMoneyPayeeStore.editPayeeResponse();

    if (response !== undefined) {
      if (response.code === 201) {
        if (MoveMoneyPayeeStore.showSummaryPageAfterEditBiller()) {
          this.setState({
            showEditPayeeSummary: true,
            showLoader: false,
            callCOP: false,
          });
        }
      } else if (
        !isEmpty(response) &&
        response.code === 422 &&
        !this.props.COP
      ) {
        this.setState({
          showEditPayeeSummary: false,
          showWarningModal: false,
          showLoader: false,
          showErrorModal: true,
          errorResponse: response,
          closeErrorModal: true,
        });
      }
    }
    const srdResponse = MoveMoneyPayeeStore.getCopCheckNeeded();
    if (srdResponse === true) {
      this.setState({ showAccountHolderName: true, copCheckNeeded: true });
    }
    const errorResponse = get(
      this.state.errorResponse,
      'coded_exceptions[0].error_status',
      undefined
    );
    if (response.code === 422 && errorResponse === 'Invalid Account') {
      this.showInlineError('sortCodeErr', 'sort_code');
      this.showInlineError('accNumErr', 'account_number');
      this.setState({
        fieldValid: {
          name: true,
          sort_code: false,
          account_number: false,
          reference: true,
          display_name: true,
        },
      });
    }
  }

  getErrorMessage() {
    const addingSameaccError =
      'You seem to be paying money into the same account that you’re withdrawing it from.';

    if (addingSameAccount) {
      return addingSameaccError;
    }
    if (this.state.errorResponse.error !== undefined) {
      return this.state.errorResponse.error.message;
    } else if (this.state.errorResponse.code === 422) {
      const invalidErrorMessage = get(
        this.state.errorResponse,
        'coded_exceptions[0].error_status'
      );
      if (invalidErrorMessage) {
        return invalidErrorMessage;
      }
      return this.props.content.duplicatePayeeErrrmsg;
    } else {
      return "Something's gone wrong!";
    }
  }

  getFormatedSortCode(sortCode) {
    let sortCodeValue = '';
    let replacedSortCode = sortCode.replace(/-/g, '');
    map(replacedSortCode, (data, index) => {
      if (index % 2 == 0 && index > 0) {
        sortCodeValue += `-${data}`;
      } else {
        sortCodeValue += data;
      }
    });
    return sortCodeValue;
  }

  getInlineErrorMessage(name) {
    switch (name) {
      case 'name':
        return this.props.content.nameErrorMessage;
      case 'reference':
        return this.props.content.referenceErrorMessage;
      case 'sort_code':
        return this.props.content.sortCodeErrorMessage;
      case 'account_number':
        return this.props.content.accountNumberErrorMessage;
      case 'display_name':
        return this.props.content.nicknameErrorMessage;
      case 'accountType':
        return this.props.content.accountTypeErrorMessage;
      case 'account_name':
        return this.props.content.accountHolderErrorMessage;
      default:
        break;
    }
  }

  getSortCodeDisplayNumber() {
    let sortcode = split(this.state.sort_code, '-');
    sortcode = NumberUtils.formatSortCode(sortcode[0]);
    return sortcode;
  }

  // To setup store for viewing payee data
  setupStore() {
    const {
      payeeData: {
        display_name,
        to_account: { sort_code, name, account_number },
        reference,
        cop_account_name: account_name,
        account: { id: accountId },
        id: beneficiaryId,
        biller_id: billerId,
      },
      billerEdit,
    } = this.props;

    MoveMoneyPayeeActionCreator.updateAllEditFiled({
      fieldValue: {
        display_name,
        sort_code,
        name,
        reference,
        single_use: false,
        account_number,
        account_name,
      },
      accountId,
      beneficiaryId,
      billerEdit,
      billerId,
    });
  }

  updateFieldInState = (fieldname, isValid) => {
    this.setState((prevState) => ({
      fieldValid: {
        ...prevState.fieldValid,
        [fieldname]: isValid,
      },
    }));
  };

  checkError(fieldname, fieldAmount, parent) {
    switch (fieldname) {
      case 'name':
        if (fieldAmount === '') {
          if (this.state.fieldBlurred[fieldname]) {
            this.showInlineError(parent, fieldname);
          }
          this.updateFieldInState(fieldname, false);
          pFlag = true;
          return true;
        } else {
          this.hideInlineError(parent, fieldname);
          this.updateFieldInState(fieldname, true);
          pFlag = false;
          return false;
        }
        break;
      case 'sort_code':
        if (fieldAmount === '' || fieldAmount.length < 6) {
          if (this.state.fieldBlurred[fieldname]) {
            this.showInlineError(parent, fieldname);
          }
          this.updateFieldInState(fieldname, false);
          sFlag = true;
          return true;
        } else {
          this.hideInlineError(parent, fieldname);
          this.updateFieldInState(fieldname, true);
          sFlag = false;
          return false;
        }
        break;
      case 'account_number':
        if (fieldAmount === '' || fieldAmount.length < 8) {
          if (this.state.fieldBlurred[fieldname]) {
            this.showInlineError(parent, fieldname);
          }
          this.updateFieldInState(fieldname, false);
          aFlag = true;
          return true;
        } else {
          this.hideInlineError(parent, fieldname);
          aFlag = false;
          this.updateFieldInState(fieldname, true);
          return false;
        }
        break;
      case 'reference':
        if (fieldAmount === '') {
          if (this.state.fieldBlurred[fieldname]) {
            this.showInlineError(parent, fieldname);
          }
          this.updateFieldInState(fieldname, false);
          rFlag = true;
          return true;
        } else {
          this.hideInlineError(parent, fieldname);
          this.updateFieldInState(fieldname, true);
          rFlag = false;
          return false;
        }
        break;
      case 'display_name':
        if (fieldAmount === '') {
          if (this.state.fieldBlurred[fieldname]) {
            this.showInlineError(parent, fieldname);
          }
          this.updateFieldInState(fieldname, false);
          nFlag = true;
          return true;
        } else {
          this.hideInlineError(parent, fieldname);
          this.updateFieldInState(fieldname, true);
          nFlag = false;
          return false;
        }
        break;
      case 'account_name':
        if (fieldAmount === '') {
          if (this.state.fieldBlurred[fieldname]) {
            this.showInlineError(parent, fieldname);
          }
          this.updateFieldInState(fieldname, false);
          anFlag = true;
          return true;
        } else {
          this.hideInlineError(parent, fieldname);
          this.updateFieldInState(fieldname, true);
          anFlag = false;
          return false;
        }
        break;
      default:
        break;
    }
  }

  closeErrorModal() {
    this.setState({ showErrorModal: false, showWarningModal: false });
    MoveMoneyPayeeStore.resetEditPaymentResponse();
  }

  closeWarningModal() {
    this.setState({ showWarningModal: false });
  }

  editDone() {
    doErrorExist = true;
    if (pFlag || rFlag || sFlag || aFlag || nFlag || anFlag) {
      if (pFlag === true) {
        this.refs.personName.focus();
        window.scrollTo(0, 0);
      } else if (sFlag === true) {
        this.refs.sortCode.focus();
        window.scrollTo(0, 0);
      } else if (aFlag) {
        this.refs.accountNumber.focus();
        window.scrollTo(0, 0);
      } else if (rFlag) {
        this.refs.Reference.focus();
      } else if (nFlag === true) {
        this.refs.nick.focus();
      } else if (anFlag === true) {
        this.refs.AccountName.focus();
      }
    } else if (
      this.props.payeeData.hasOwnProperty('biller_id') &&
      MoveMoneyPayeeStore.getCopCheckNeeded() &&
      !this.state.account_name
    ) {
      this.showInlineError('accNameErr', 'account_name');

      this.setState((prevState) => ({
        fieldValid: {
          ...prevState.fieldValid,
          account_name: false,
        },
      }));
    } else {
      doErrorExist = false;
    }

    const errorResponse = get(
      this.state.errorResponse,
      'coded_exceptions[0].error_status',
      undefined
    );
    if (
      !isEmpty(this.state.errorResponse) &&
      errorResponse === 'Invalid Account'
    ) {
      const oneFieldInvalid =
        !this.state.fieldValid['sort_code'] ||
        !this.state.fieldValid['account_number'];
      const bothFieldsInvalid =
        !this.state.fieldValid['sort_code'] &&
        !this.state.fieldValid['account_number'];
      // if one SCAN field is updated, user can proceed
      doErrorExist = oneFieldInvalid ? false : bothFieldsInvalid;
    }

    if (!doErrorExist) {
      if (this.isAddingSameAccount()) return;
      this.setState({ showWarningModal: true, closeModal: true });

      const { reference, account_name, display_name } = this.state;
      const { payeeData } = this.props;
      if (
        MoveMoneyPayeeStore.getCopCheckNeeded() &&
        (reference !== payeeData.reference ||
          account_name !== payeeData.cop_account_name)
      )
        if (display_name === '' || account_name === '' || reference === '') {
          this.setState({
            showWarningModal: false,
            closeModal: false,
          });
        } else {
          this.setState({
            showWarningModal: true,
            closeModal: true,
          });
        }
      if (this.state.isScheduledPaymentsWarningShown) {
        this.updateAllDetails();
      }
    }
  }

  goToManagePayee() {
    this.props.goToManagePayee();
  }

  goToMoveMoneyPages(newValues) {
    this.props.goToMoveMoneyPage(newValues);
  }

  goToViewPage(e) {
    if (!this.props.goToViewPage) {
      this.props.goToMoveMoneyPage();
    } else {
      if (MoveMoneyPayeeStore.getCopCheckNeeded()) {
        this.props.goToViewPage();
      } else {
        this.props.goToViewPage();
        MoveMoneyPayeeStore.resetStore();
      }
    }
    if (!isEmpty(e)) e.preventDefault();
  }

  hideInlineError(parent, name) {
    this.refs[parent].className = 'c-field';
    this.refs[name].innerHTML = '';
  }

  isAddingSameAccount() {
    addingSameAccount = false;
    if (
      this.props.payeeData.account.sort_code ===
        this.removeHypenFromString(this.state.sort_code) &&
      this.state.account_number === this.props.payeeData.account.account_number
    ) {
      addingSameAccount = true;
      this.setState({
        showLoader: false,
        showErrorModal: true,
        closeErrorModal: true,
      });
    }
    return addingSameAccount;
  }

  moveFocusOnSortCode(e) {
    if (e.target.name === this.props.content.payeeRequestPacket_sort_code) {
      this.updateValueState(
        e.target.name,
        this.removeHypenFromString(e.target.value)
      );
    }
  }

  removeHypenFromString(value) {
    let sortedValue = '';
    map(value, (data) => {
      if (data !== '-') {
        sortedValue += data;
      }
    });
    return sortedValue;
  }

  returnLoader() {
    window.scrollTo(0, 0);

    return <LoaderComponent type="large" />;
  }

  // Shows biller edit details on click of biller payee
  showEditBillerDetails() {
    let bodyContent = (
      <div>
        <p>{this.props.content.editPayeeWarningPopup1}</p> <br />
        <p>{this.props.content.editPayeeWarningPopup2}</p>
      </div>
    );
    let footerButtons = (
      <div>
        <Button
          btnName="Cancel"
          className="c-btn c-btn--secondary c-modal__button"
          onClick={this.closeWarningModal}
        />
        <Button
          dataTestId="edit-biller-modal-ok-button"
          btnName="OK"
          className="c-btn c-btn--default c-modal__button"
          onClick={this.updateAllDetails}
        />
      </div>
    );
    return (
      <div>
        {this.state.showEditPayeeSummary ? (
          <EditPayeeSummary
            goToMoveMoneyPage={this.goToMoveMoneyPages}
            goToManagePayee={this.goToManagePayee}
            content={this.props.content}
            showCopComponent={this.props.showCopComponent}
          />
        ) : (
          <div>
            <div>
              <StepHeader
                showheaderCrumbs="true"
                onClick={this.goToViewPage}
                headerCrumbsMessage="Back"
                headerTitle={this.props.content.editPageheaderTitle}
              />
              <div
                className="row add-edit-payee__form add-edit-payee__form-"
                data-test-id="add-edit-payee--biller"
                role="main"
              >
                <div className="col-xl1-18 col-lg1-18 col-md1-18">
                  <div className="row">
                    <div className="col-md1-18">
                      <dl className="c-definitions">
                        <dt className="c-definitions__key">Name</dt>
                        <dd className="c-definitions__value">
                          {this.state.name}
                        </dd>

                        <dt className="c-definitions__key">Sortcode</dt>
                        <dd className="c-definitions__value">
                          {this.state.sort_code}
                        </dd>

                        <dt className="c-definitions__key">Account number</dt>
                        <dd className="c-definitions__value">
                          {this.state.account_number}
                        </dd>
                      </dl>
                    </div>
                  </div>

                  <div className="c-field" ref="refErr">
                    <label
                      className="c-field__label c-field__label--block"
                      htmlFor="f1"
                    >
                      Reference
                      <div className="c-field__instructions">
                        They’ll see this. You can add customer references,
                        credit card or roll numbers here (if you have them).
                      </div>
                    </label>
                    <div className="c-field__controls">
                      <input
                        className="c-field__input"
                        type="text"
                        name="reference"
                        aria-required="true"
                        data-parent="refErr"
                        id="f1"
                        onBlur={this.onBlur}
                        value={this.state.reference}
                        onChange={this.onChange}
                        ref="Reference"
                      />
                      <div
                        className="c-field__message"
                        id="referenceMsg"
                        ref="reference"
                        role="alert"
                      />
                    </div>
                  </div>
                  {MoveMoneyPayeeStore.getCopCheckNeeded() && (
                    <div className="c-field" ref="accNameErr">
                      <label
                        className="c-field__label c-field__label--block"
                        htmlFor="accountName"
                      >
                        {this.props.content.accountHolderName}
                        <div className="c-field__instructions">
                          {this.props.content.accountNameHintText}
                        </div>
                      </label>
                      <div className="c-field__controls">
                        <input
                          className="c-field__input"
                          onBlur={this.onBlur}
                          data-parent="accNameErr"
                          type="text"
                          name={
                            this.props.content.payeeRequestPacket_account_name
                          }
                          id="accountName"
                          onChange={this.onChange}
                          value={this.state.account_name}
                          maxLength="138"
                          size="138"
                          ref="AccountName"
                          aria-required="true"
                          aria-invalid="false"
                        />
                        <div
                          className="c-field__message"
                          ref="account_name"
                          role="alert"
                          id="accNameErr"
                        />
                      </div>
                    </div>
                  )}

                  <div className="c-field" ref="nicknameErr">
                    <label
                      className="c-field__label c-field__label--block"
                      htmlFor="nickname"
                    >
                      Nickname
                      <div className="c-field__instructions">
                        {this.props.content.nicknameHintTextSRD}
                      </div>
                    </label>
                    <div className="c-field__controls">
                      <input
                        className="c-field__input"
                        type="text"
                        name="display_name"
                        aria-required="true"
                        data-parent="nicknameErr"
                        id="nickname"
                        onBlur={this.onBlur}
                        value={this.state.display_name}
                        onChange={this.onChange}
                        maxLength="50"
                        size="50"
                        ref="nick"
                      />
                      <div
                        className="c-field__message"
                        id="nicknameMsg"
                        ref="display_name"
                        role="alert"
                      />
                    </div>
                  </div>

                  <div className="add-edit-payee__form__options">
                    <button
                      className="c-btn c-btn--secondary"
                      onClick={this.goToViewPage}
                    >
                      Back
                    </button>
                    <button
                      data-test-id="add-edit-payee--confirm"
                      className="c-btn c-btn--default"
                      disabled={this.state.updateDetails}
                      onClick={this.editDone}
                    >
                      Update details
                    </button>
                  </div>
                </div>
              </div>
              {!this.state.isScheduledPaymentsWarningShown &&
              this.state.showWarningModal ? (
                <PatternLibModalComponent
                  show={this.state.closeModal}
                  customClass={'c-modal'}
                  onHide={() => this.setState({ closeModal: false })}
                  bsSize={'medium'}
                  modalHeading={'Scheduled payments may need updated'}
                  modalBody={bodyContent}
                  modalFooter={footerButtons}
                  modalInContainer={false}
                  closeButton
                />
              ) : (
                ''
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  showEditDetails() {
    let sortcodeValue = this.state.sort_code;
    let bodyContent = (
      <div>
        <p>{this.props.content.editPayeeWarningPopup1}</p> <br />
        <p>{this.props.content.editPayeeWarningPopup2}</p>
      </div>
    );
    let footerButtons = (
      <div>
        <Button
          btnName="Cancel"
          className="c-btn c-btn--secondary c-modal__button"
          onClick={this.closeWarningModal}
        />
        <Button
          dataTestId="edit-biller-modal-ok-button"
          btnName="OK"
          className="c-btn c-btn--default c-modal__button"
          onClick={this.updateAllDetails}
        />
      </div>
    );

    const maxNameChars = 138;
    const stateNameKey = this.state.useLegacyName ? 'name' : 'account_name';
    const nameStateValue = this.state[stateNameKey];
    const nameErrRef = this.state.useLegacyName ? 'nameErr' : 'accNameErr';
    const nameRef = this.state.useLegacyName ? 'name' : 'AccountName';

    return (
      <div>
        {this.state.showEditPayeeSummary ? (
          <EditPayeeSummary
            goToMoveMoneyPage={this.goToMoveMoneyPages}
            goToManagePayee={this.goToManagePayee}
            content={this.props.content}
            showCopComponent={this.props.showCopComponent}
          />
        ) : (
          <div>
            <div>
              <StepHeader
                showheaderCrumbs="true"
                onClick={this.goToViewPage}
                headerCrumbsMessage="Back"
                headerTitle={this.props.content.editPageheaderTitle}
              />
              <div
                className="row add-edit-payee__form"
                data-test-id="add-edit-payee--non-biller"
                role="main"
              >
                <div className="col-xl1-18 col-lg1-18 col-md1-18">
                  {this.state.accountType ? (
                    <div className="c-field" ref="typeErr">
                      <label
                        className="c-field__label c-field__label--block"
                        htmlFor="name1"
                      >
                        Account Type
                      </label>

                      <GroupFieldWrapper
                        titleContent={
                          <VisuallyHiddenBody>
                            {this.props.content.editPayeeAccountType}
                          </VisuallyHiddenBody>
                        }
                      >
                        <div className="c-field__controls">
                          <div className="c-radio">
                            <GenericRadio.InlineSet
                              groupName="radio-group-personal"
                              items={radioItems}
                              onChange={(accountType) =>
                                this.setState({
                                  accountType,
                                  updateDetails: false,
                                })
                              }
                              selectedId={this.state.accountType}
                            />
                          </div>
                          <div
                            className="c-field__message"
                            id="type"
                            ref="name"
                            role="alert"
                            name="accountType"
                            data-parent="typeErr"
                          />
                        </div>
                      </GroupFieldWrapper>
                    </div>
                  ) : (
                    <div className="c-field--error" ref="typeErr">
                      <label
                        className="c-field__label c-field__label--block"
                        htmlFor="name1"
                      >
                        Account Type
                      </label>

                      <GroupFieldWrapper
                        titleContent={
                          <VisuallyHiddenBody>
                            {this.props.content.editPayeeAccountType}
                          </VisuallyHiddenBody>
                        }
                      >
                        <div className="c-field__controls">
                          <div className="c-radio" name="abc">
                            <GenericRadio.InlineSet
                              groupName="radio-group-personal"
                              items={radioItems}
                              onChange={(accountType) =>
                                this.setState({
                                  accountType,
                                  updateDetails: false,
                                })
                              }
                              selectedId={this.state.accountType}
                            />
                          </div>
                          <div
                            id="type"
                            name="accountType"
                            className="c-field__message"
                            role="alert"
                          >
                            {this.getInlineErrorMessage('accountType')}
                          </div>
                        </div>
                      </GroupFieldWrapper>
                    </div>
                  )}

                  <div className="c-field" ref={nameErrRef}>
                    <label
                      className="c-field__label c-field__label--block"
                      htmlFor="name"
                    >
                      Name
                    </label>
                    <div className="c-field__controls">
                      <input
                        className="c-field__input"
                        type="text"
                        name={stateNameKey}
                        id="name"
                        aria-required="true"
                        data-parent={nameErrRef}
                        value={nameStateValue}
                        disabled={this.state.isBiller}
                        onChange={this.onChange}
                        onBlur={this.onBlur}
                        ref={nameRef}
                        maxLength={maxNameChars}
                        size={maxNameChars}
                      />
                      <div
                        className="c-field__message"
                        id={nameErrRef}
                        ref={stateNameKey}
                        role="alert"
                      >
                        {this.getInlineErrorMessage(stateNameKey)}
                      </div>
                    </div>
                  </div>

                  <div className="c-field" ref="nicknameErr">
                    <label
                      className="c-field__label c-field__label--block"
                      htmlFor="nickname1"
                    >
                      Nickname
                      <div className="c-field__instructions">
                        {this.props.content.nicknameHintText}
                      </div>
                    </label>
                    <div className="c-field__controls">
                      <input
                        className="c-field__input"
                        data-test-id="edit-payee--nickname"
                        type="text"
                        name="display_name"
                        aria-required="true"
                        data-parent="nicknameErr"
                        id="nickname1"
                        value={this.state.display_name}
                        onChange={this.onChange}
                        maxLength="50"
                        size="50"
                        ref="nick"
                        onBlur={this.onBlur}
                      />
                      <div
                        className="c-field__message"
                        id="nicknameMsg"
                        ref="display_name"
                        role="alert"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm1-8">
                      <div className="c-field" ref="sortCodeErr">
                        <label
                          className="c-field__label c-field__label--block"
                          htmlFor="sortcode"
                        >
                          {this.props.content.theirSortCode}
                        </label>
                        <div className="c-field__controls">
                          <input
                            className="c-field__input"
                            disabled={this.state.isBiller}
                            aria-required="true"
                            data-parent="sortCodeErr"
                            type="text"
                            name="sort_code"
                            id="sortcode"
                            value={sortcodeValue}
                            onChange={this.onChange}
                            onFocus={this.moveFocusOnSortCode}
                            onBlur={this.onBlur}
                            maxLength="8"
                            size="8"
                            ref="sortCode"
                          />
                          <div
                            className="c-field__message"
                            id="sortcodeMsg"
                            ref="sort_code"
                            role="alert"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm1-16">
                      <div className="c-field" ref="accNumErr">
                        <label
                          className="c-field__label c-field__label--block"
                          htmlFor="accountNumber"
                        >
                          {this.props.content.theirAccountNo}
                        </label>
                        <div className="c-field__controls">
                          <input
                            className="c-field__input"
                            type="text"
                            aria-required="true"
                            data-parent="accNumErr"
                            name="account_number"
                            id="accountNumber"
                            value={this.state.account_number}
                            disabled={this.state.isBiller}
                            onBlur={this.onBlur}
                            onChange={this.onChange}
                            maxLength="8"
                            size="8"
                            ref="accountNumber"
                          />
                          <div
                            className="c-field__message"
                            id="accountNumberMsg"
                            ref="account_number"
                            role="alert"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="c-field" ref="refErr">
                    <label
                      className="c-field__label c-field__label--block"
                      htmlFor="f1"
                    >
                      Reference
                      <div className="c-field__instructions">
                        They’ll see this. You can add customer references,
                        credit card or roll numbers here (if you have them).
                      </div>
                    </label>
                    <div className="c-field__controls">
                      <input
                        className="c-field__input"
                        type="text"
                        name="reference"
                        aria-required="true"
                        data-parent="refErr"
                        id="f1"
                        value={this.state.reference}
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                        ref="Reference"
                      />
                      <div
                        className="c-field__message"
                        id="referenceMsg"
                        ref="reference"
                        role="alert"
                      />
                    </div>
                  </div>
                  <div className="add-edit-payee__form__options">
                    <button
                      className="c-btn c-btn--secondary"
                      onClick={this.goToViewPage}
                    >
                      Back
                    </button>
                    <button
                      className="c-btn c-btn--default"
                      data-test-id="add-edit-payee--confirm"
                      disabled={this.state.updateDetails}
                      onClick={this.editDone}
                    >
                      Update details
                    </button>
                  </div>
                </div>
                {!this.state.isScheduledPaymentsWarningShown &&
                this.state.showWarningModal ? (
                  <PatternLibModalComponent
                    show={this.state.closeModal}
                    customClass={'c-modal'}
                    onHide={() => this.setState({ closeModal: false })}
                    bsSize={'medium'}
                    modalHeading={'Scheduled payments may need updated'}
                    modalBody={bodyContent}
                    modalFooter={footerButtons}
                    modalInContainer={false}
                    closeButton
                  />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  showInlineError(parent, name) {
    this.refs[parent].className += ' c-field--error';
    this.refs[name].innerHTML = this.getInlineErrorMessage(name);
  }

  updateAllDetails() {
    const {
      payeeData: {
        cop_account_type,
        confirmation_of_payee,
        to_account,
        to_account: {
          account_number: accountNumber,
          sort_code: sortCode,
          name: accountName,
        },
        account,
        reference: payeeReference,
        display_name: displayName,
        cop_account_name,
      },
      isSMEUser,
      nestedCopEdit,
      nestedEditData,
      nestedContinue,
    } = this.props;

    const {
      account_number,
      name,
      reference,
      sort_code,
      display_name,
      accountType,
      account_name,
    } = this.state;
    const payeePayload = {
      confirmation_of_payee: {
        cop_matching_outcome: confirmation_of_payee?.cop_matching_outcome,
        cop_reason_code: confirmation_of_payee?.cop_reason_code,
        cop_status: confirmation_of_payee?.cop_status,
      },
      cop_account_name: account_name,
      cop_account_type: accountType,
    };

    if (!account_name) {
      if (MoveMoneyPayeeStore.getCopCheckNeeded() === false) {
        this.setState({ callCOP: false, showLoader: true });
        MoveMoneyPayeeActionCreator.editPayee({ payeePayload });
      } else {
        this.setState({
          callCOP: true,
          showLoader: false,
          showWarningModal: false,
          isScheduledPaymentsWarningShown: true,
        });
      }
    } else if (
      this.removeHypenFromString(sort_code) === sortCode &&
      account_number === accountNumber &&
      name === accountName &&
      accountType === cop_account_type &&
      reference === payeeReference &&
      account_name === cop_account_name &&
      display_name !== displayName
    ) {
      if (nestedCopEdit) {
        nestedContinue(nestedEditData);
      } else {
        this.setState({ callCOP: false, showLoader: true });
        MoveMoneyPayeeActionCreator.editPayee({ payeePayload });
        const sortCode = this.removeHypenFromString(this.state.sort_code);
        if (
          isSMEUser &&
          (to_account.sort_code !== sortCode ||
            to_account.account_number !== account_number)
        ) {
          const beneficiaryEventData = beneficiaryUpdateEventPayload(
            this.state,
            {
              account,
              to_account,
              sortCode,
            }
          );
          AnalyticsUtil.analyticAction(
            config.analytics.analytics_experience_activity,
            config.analytics.analytics_event_method_interacted,
            beneficiaryEventData,
            'click',
            true
          );
        }
      }
    } else {
      this.setState({
        callCOP: true,
        showLoader: false,
        showWarningModal: false,
        isScheduledPaymentsWarningShown: true,
      });
    }
  }

  updateValueState(name, value) {
    this.setState({
      [name]: value,
    });
  }

  handleCOP() {
    this.setState((prevState) => ({
      callCOP: false,
      tryCount: prevState.tryCount + 1,
    }));
  }

  renderCopComponent() {
    const { session, envConfig, isSMEUser, user, payeeData, nestedCopEdit } =
      this.props;
    const {
      account_name,
      sort_code,
      account_number,
      name,
      reference,
      accountType,
      tryCount,
      useLegacyName,
    } = this.state;

    const sessionCOPChecks = AppStore.getSessionCOPChecks();

    let copAccountName = name;
    if (!useLegacyName || payeeData.hasOwnProperty('biller_id')) {
      copAccountName = account_name || name;
    }

    const cop = {
      accountName: copAccountName,
      accountNumber: account_number,
      sortCode: this.removeHypenFromString(sort_code),
      accountType: accountType === 'Personal' ? 'Personal' : 'Business',
      reference: reference,
      beneficiaryId: '',
      customerId: user.id,
      customerType: isSMEUser ? 'business' : 'retail',
      page: 'MakeMatch',
      tryCount: tryCount,
    };
    const handleComplete = nestedCopEdit ? nestedCopEdit : this.handleCopResult;

    return (
      <COP
        envConfig={envConfig}
        session={getSessionInfo(session)}
        sessionCOPChecks={sessionCOPChecks}
        user={this.state.user}
        cop={cop}
        copCheckTriggered={copCheckTriggeredHandler}
        handleCancel={() => this.goToViewPage()}
        handleEdit={this.handleCOP}
        handleComplete={(copResult) => {
          handleComplete(copResult, cop);
        }}
      />
    );
  }

  renderStepUpComponent = () => {
    const { content, goToViewPage } = this.props;

    return (
      <StepUpWrapper
        content={content}
        handleSuccess={() => {
          this.setState({
            callCOP: false,
            showLoader: true,
          });

          MoveMoneyPayeeActionCreator.editPayee({
            payeePayload:
              MoveMoneyPayeeStore.getUnauthorisedBeneficiaryDetails(),
            currentPayee: MoveMoneyStore.getSelectedPayee(),
          });
        }}
        handleCancel={() => {
          MoveMoneyStore.resetSelectedPayee();
          goToViewPage();
        }}
      />
    );
  };

  buildCopPayeePayload(copCheckResult, name) {
    if (copCheckResult) {
      const {
        payeeName,
        payeeType,
        result: {
          cop_matching_outcome,
          matching_outcome,
          cop_reason_code,
          reason_code_description,
        } = {},
      } = copCheckResult;

      const matchingOutcome =
        cop_reason_code !== StringConstant.ERR1 &&
        cop_reason_code !== StringConstant.ERR2
          ? cop_matching_outcome
          : null;

      return {
        cop_account_name: name || payeeName,
        cop_account_type: payeeType,
        confirmation_of_payee: {
          cop_matching_outcome: matchingOutcome,
          cop_reason_code,
          reason_code_description,
          matching_outcome,
        },
      };
    } else {
      return {
        cop_account_name: name,
        cop_account_type:
          this.state.accountType === 'Personal' ? 'Personal' : 'Business',
        confirmation_of_payee: {
          cop_matching_outcome: null,
          cop_reason_code: null,
          matching_outcome: null,
          reason_code_description: 'CoP Service Unavailable',
        },
      };
    }
  }

  handleCopResult(result) {
    const currentPayee = MoveMoneyStore.getSelectedPayee();
    const copName = this.state.useLegacyName
      ? this.state.name
      : this.state.account_name;

    let isNameUpdated = false;
    let nameToUse = copName;

    if (result) {
      isNameUpdated =
        result.payeeName !== get(this.state, 'account_name', 'name');

      nameToUse = isNameUpdated
        ? result.payeeName
        : this.props.payeeData.hasOwnProperty('biller_id') &&
          get(this.state, 'account_name', copName);
    }

    const payeePayload = this.buildCopPayeePayload(result, nameToUse);

    this.setState({
      callCOP: false,
      showLoader: true,
      showEditPayeeSummary: true,
    });
    MoveMoneyPayeeActionCreator.editPayee({ payeePayload, currentPayee });
    this.props.editCOPSuccess && this.props.editCOPSuccess();
  }

  render() {
    let footerButtons = (
      <div>
        <button
          className="c-btn c-btn--default c-modal__button"
          onClick={this.closeErrorModal}
        >
          OK
        </button>
      </div>
    );
    return (
      <div className="container add-edit-payee" id="site-main" tabIndex="-1">
        {this.state.showLoader
          ? this.returnLoader()
          : this.state.callCOP
          ? this.renderCopComponent()
          : !this.props.isSMEUser && this.state.isStepUpMode
          ? this.renderStepUpComponent()
          : this.props.billerEdit
          ? this.showEditBillerDetails()
          : this.showEditDetails()}
        {this.state.showErrorModal ? (
          <PatternLibModalComponent
            show={this.state.closeErrorModal}
            customClass={'c-modal'}
            onHide={() => this.setState({ closeErrorModal: false })}
            bsSize={'medium'}
            modalHeading={''}
            modalBody={this.getErrorMessage()}
            modalFooter={footerButtons}
            modalInContainer={false}
            closeButton
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

EditPayeePage.propTypes = {
  content: PropTypes.object,
  payeeData: PropTypes.object.isRequired,
  goToMoveMoneyPage: PropTypes.func,
  goToViewPage: PropTypes.func,
  goToManagePayees: PropTypes.func,
  billerEdit: PropTypes.bool,
  isSMEUser: PropTypes.bool.isRequired,
  editCOPSuccess: PropTypes.func,
};

EditPayeePage.defaultProps = {
  content: {},
  payeeData: {},
  billerEdit: false,
};

export default EditPayeePage;
